import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PortfolioImproved from "./pages/PortfolioImproved";

function App() {
  return (
    <Routes>
      <Route path="/" element={<PortfolioImproved />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
